import fuzzysort from 'fuzzysort'

import { MAX_AUTOCOMPLETE_SUGGESTIONS } from './helpers'
import { TComboboxItemWithData, TMentionEmoji } from './types'

let emojiCache: Array<{
    name: string
    emoji: string
    keyword: string
}>

/**
 * If user types :), we want to suggest the emojis with the keyword "smile".
 * Similarly, if user types :D, we want to suggest the emojis with the keyword "grin" and so on.
 */
const emojiShortCodes: { [x: string]: string } = {
    ':)': 'smile',
    ':))': 'laugh',
    ':d': 'grin',
    ':p': 'tongue',
    ':o': 'surprised',
    ':(': 'sad',
    ":'(": 'cry',
}

const EMOJI_SEARCH_PATTERN = /[^a-zA-Z0-9\s]/gi

export const emojiSearch = async (
    query: string,
): Promise<TComboboxItemWithData<TMentionEmoji>[]> => {
    const { emojis } = await import('data/emojis')

    // prepare the data once, search on []keywords and name.
    emojiCache =
        emojiCache ??
        Object.values(emojis).map((emoji) => {
            const keywords = emoji.keywords
                .map((word) => word.replace(/[^a-z0-9-_\s]/gi, ''))
                .join(',')
            return { emoji: emoji.default, keywords: keywords, name: emoji.name }
        })

    let _query = ':' + query.toLowerCase()

    // If the query is a short code, convert it to the corresponding emoji keyword for better search results
    if (emojiShortCodes[_query]) {
        _query = emojiShortCodes[_query]
    }

    return fuzzysort
        .go(_query.replace(EMOJI_SEARCH_PATTERN, ''), emojiCache, {
            keys: ['name', 'keywords'],
            all: false,
            limit: 5,
        })
        .map((r) => ({
            name: r.obj.name,
            emoji: r.obj.emoji,
        }))
        .slice(0, MAX_AUTOCOMPLETE_SUGGESTIONS)
        .map((_emoji) => ({
            data: _emoji,
            text: _emoji.name,
            key: _emoji.emoji,
        }))
}
